import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientConfirmDataAccuracyMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClient } from './helpers';

export const useLegalClientConfirmDataAccuracy = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientConfirmDataAccuracyMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientConfirmDataAccuracy
      ? parseLegalClient(data.legalClientConfirmDataAccuracy)
      : undefined,
    loading,
    error,
    confirmData: useCallback(
      async (id: string) => {
        const res = await handle({ variables: { id } });
        return res.data?.legalClientConfirmDataAccuracy
          ? parseLegalClient(res.data.legalClientConfirmDataAccuracy)
          : undefined;
      },
      [handle]
    ),
  };
};
